exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "team-calendar-list .team-calendar-list-wrapper{margin-top:20px}team-calendar-list .list-empty{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin:45px 20px 0;text-align:center;border-bottom:1px solid #eaebed}team-calendar-list .list-empty p{font-size:20px;margin:15px 0 30px;font-family:Stag Sans}team-calendar-list .list-empty .icon-warning{font-size:60px}team-calendar-list .list-empty .icon-warning,team-calendar-list .list-empty p{color:#0072c9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarList.scss
// module id = 1316
// module chunks = 0